import { MouseEventHandler } from "react";

import { ModalTab } from "./ModalTab";
import { Footer, Root, SidebarButtonGroup } from "./styles";

type SidebarModalTab = {
  tabText: string;
  onClick: MouseEventHandler;
  isCurrent?: boolean;
};

type SidebarMenuProps = {
  tabs: SidebarModalTab[];
  footer: React.ReactNode;
};

export function SidebarMenu({ tabs, footer }: SidebarMenuProps) {
  return (
    <Root as="nav" data-testid={`Modal${SidebarMenu.name}`}>
      <SidebarButtonGroup align="start" direction="vertical" role="tablist">
        {tabs.map(({ tabText, isCurrent, onClick }, index) => {
          return (
            <ModalTab key={`modal-tab-${index}`} isCurrent={isCurrent} onClick={onClick}>
              {tabText}
            </ModalTab>
          );
        })}
      </SidebarButtonGroup>
      <Footer>{footer}</Footer>
    </Root>
  );
}
